module.exports = __webpack_public_path__ + "img/main-banner-1920.ad12cfcc.jpg";